import React from 'react'

import { ContributionSummary, ProductsList } from '@components/common'
import { PriceString } from '@fourthwall/components'

import type { Order } from '../../Order.types'

type DonationItemProps = {
  donation: Order['donation']
}

export const DonationItem = ({ donation }: DonationItemProps) => {
  return (
    <ContributionSummary title="Donation">
      <ContributionSummary.Section>
        <ProductsList size="large">
          <ProductsList.Item name="Donation" price={<PriceString {...donation} />} donation />
        </ProductsList>
      </ContributionSummary.Section>
    </ContributionSummary>
  )
}
